import * as React from 'react'

import { F0Box, F0Card, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import catalogBannerImage from './device-catalog-banner.jpg'

export const CatalogBannerCard: React.FC = () => {
  return (
    <F0Card onClick={() => window.open('/device-catalog', '_blank', 'noopener,noreferrer')}>
      <F0Box display="flex" flexDirection="row">
        <F0Box display="flex" flexDirection="column">
          <F0Text
            variant="label"
            content={i18n.t('add_employee_modal.devices_step.catalog_card_title')}
          />
          <F0Text
            variant="description"
            content={i18n.t('add_employee_modal.devices_step.catalog_card_description')}
          />
        </F0Box>
        <img src={catalogBannerImage} className="w-28 h-16 object-cover rounded-lg flex-shrink-0" />
      </F0Box>
    </F0Card>
  )
}
